import type { Actions, SetColumnLayoutAction, SetExtendedWidthAction } from './types';

export const setExtendedContentWidth: SetExtendedWidthAction =
	(extendedContentWidth: number) =>
	({ setState }) => {
		setState({ extendedContentWidth });
	};

export const setColumnLayout: SetColumnLayoutAction =
	() =>
	({ setState, getState }) => {
		const { extendedContentWidth, columnLayout } = getState();
		const columnSum = columnLayout.reduce((acc, curr) => acc + curr.width, 0);
		const lastColumnWidth = extendedContentWidth - columnSum + (columnLayout.at(-1)?.width ?? 0);
		const updatedColumnLayout = columnLayout.map((column, index) => {
			if (index === columnLayout.length - 1) {
				return { ...column, width: lastColumnWidth };
			}
			return column;
		});

		setState({ columnLayout: updatedColumnLayout });
	};

export const actions: Actions = {
	setExtendedContentWidth,
	setColumnLayout,
};

export type { Actions };
